import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import { Box, IconButton, InputAdornment, Pagination, PaginationItem, Stack, Typography, styled, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import TokenCard from "../../components/cards/token";
import { SearchToken, CardGrid, OrderBoxRoot } from "./DashboardStyles";
import PageBox from "../../components/layout/pageBox";
import { useTokens } from "../../hooks/token";
import { useChainInfo } from "../../hooks/config";

const HiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clipPath: inset(50%);
    height: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 100%;
`

const Option = styled('button') <{ checked: boolean }>`
    background: none;
    color: white;
    border: none;
    font-weight: bold;
    cursor: pointer;
    border-radius: 12px;
    padding: 4px;
    ${({ checked }) => (
        checked ? `
            background: #E12D85;
        ` : ''
    )}
`

const CreateButton = styled(Link)`
    border-radius: 8px;
    border: 1px solid #999;
    box-shadow: 0px 6px 8px 2px #9996 inset, 0px -4px 8px 0px #9991 inset, 0 0 10px #0008;
    color: white;
    font-family: Arial;
    font-weight: 400;
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    cursor: pointer;
    text-decoration: none;
    & > span {
        &:nth-child(8n) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 0;
        }
        &:nth-child(8n+1) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 0.2s;
        }
        &:nth-child(8n+2) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 0.4s;
        }
        &:nth-child(8n+3) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 0.6s;
        }
        &:nth-child(8n+4) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 0.8n;
        }
        &:nth-child(8n+5) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 1s;
        }
        &:nth-child(8n+6) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 1.2s;
        }
        &:nth-child(8n+7) {
            animation: opacity-animation2 1.6s infinite linear;
            animation-delay: 1.4s;
        }
    }
    &:hover {
        border-color: #AAA;
        box-shadow: 0px 4px 4px 2px rgba(6, 182, 212, 0.2) inset, 0px -4px 8px 0px rgba(6, 182, 212, 0.1) inset, 0 0 10px #0008;
    }
    ${({ theme }) => theme.breakpoints.down(800)} {
        font-size: 24px;
    }
`

const SearchButton = styled('button')`
    background: transparent;
    border-radius: 8px;
    border: 1px solid #999;
    box-shadow: 0px 6px 8px 2px #9996 inset, 0px -4px 8px 0px #9991 inset;
    color: white;
    font-family: Arial;
    font-weight: 400;
    font-size: 32px;
    display: flex;
    align-items: center;
    padding: 13px;
    cursor: pointer;
    text-decoration: none;
    backdrop-filter: blur(10px);
    &:hover {
        border-color: #AAA;
        box-shadow: 0px 4px 4px 2px rgba(6, 182, 212, 0.2) inset, 0px -4px 8px 0px rgba(6, 182, 212, 0.1) inset;
    }
`

const ToolBox = styled(Box)`
`

// const sleep = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

function ComboBox(props: any) {
    const [open, setOpen] = useState(false)
    return <OrderBoxRoot onClick={() => setOpen(!open)} {...props}>
        <Box component="label" display="flex" gap="4px" alignItems="center">
            <Typography component="span" fontSize={14}>{props.label}: </Typography>
            <Typography component="span" fontSize={14}>{props.values[props.value]}</Typography>
            <ArrowDownIcon sx={{ ml: 'auto' }} />
        </Box>
        {
            open &&
            <>
                <div className="overlay" onClick={() => setOpen(false)} />
                <Box className="menu">
                    <ul>
                        {
                            Object.entries(props.values)?.map(([key, label]: [string, any]) =>
                                <li className={key === props.value ? 'active' : ''} onClick={() => {
                                    props.onChange?.(key)
                                    setOpen(false)
                                }}>
                                    {label}
                                    {
                                        key === props.value && <CheckIcon sx={{ height: 18 }} />
                                    }
                                </li>
                            )
                        }
                    </ul>
                </Box>
            </>
        }
    </OrderBoxRoot>
}

function DashboardPage() {
    // const { address } = useWeb3ModalAccount()
    // const { walletProvider } = useWeb3ModalProvider()
    // const { code } = useParams()

    // let checkedStatus = localStorage.getItem('checked');
    // const [open, setOpen] = React.useState(checkedStatus !== null && JSON.parse(checkedStatus) === true ? false : true);
    const [network, setNetwork] = React.useState('all');
    const [orderType, setOrderType] = React.useState('marketcap');
    const [orderFlag] = React.useState('DESC');
    const [searchWord, setSearchWord] = React.useState('');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageTrendsNumber, setPageTrendsNumber] = React.useState(1);
    const [inSearch, setInSearch] = React.useState(false);
    const [width, setWidth] = useState(0);
    const elementRef = useRef<any>();

    const { chains } = useChainInfo()
    const isMobile = useMediaQuery('(max-width: 800px)')

    const searchTokenInputProps = useMemo(() => ({
        startAdornment: (
            <InputAdornment position="start">
                {
                    inSearch
                    ? <ArrowBackIcon onClick={() => setInSearch(false)} />
                    : <SearchIcon sx={{ width: { md: 36, sm: 24, xs: 24 }, height: { md: 36, sm: 24, xs: 24 } }} />
                }
            </InputAdornment>
        ),
        endAdornment: (
            <InputAdornment style={{ cursor: "pointer", visibility: searchWord.length > 0 ? 'visible' : 'hidden' }} position="end" onClick={() => {
                setSearchWord('')
            }}>
                <CloseIcon sx={{ height: 18 }} />
            </InputAdornment>
        )
    }), [searchWord, inSearch])

    const pageSize = useMemo(() => {
        const cols = Math.floor((width + 32) / 382)
        if (cols === 0)
            return 5
        if (cols < 3)
            return cols * 5
        if (cols < 5)
            return cols * 4
        return cols * 3
    }, [width])

    const pageTrendSize = useMemo(() => {
        return Math.floor((width + 12) / 192)
    }, [width])

    const { tokens, count } = useTokens({
        network, searchWord, orderType, orderFlag, pageNumber, pageSize
    })

    const { tokens: trends } = useTokens({
        pageNumber: pageTrendsNumber, pageSize: pageTrendSize
    })

    const totalPage = useMemo(() => {
        return Math.floor(count / pageSize) + (count % pageSize === 0 ? 0 : 1)
    }, [count, pageSize])

    useLayoutEffect(() => {
        const updateWidth = () => {
            if (elementRef.current) {
                setWidth(elementRef.current.offsetWidth);
            }
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [])

    const handleChange = (event: any, value: any) => {
        setPageNumber(value);
        // This logs the current page number to the console
    };

    // const uploadLogo = async (img: any) => {
    //     let formData = new FormData(); // instantiate it
    //     formData.set('image', img);
    //     const r = axios.post(`${SERVER_URL}/tokens/upload`, formData, {
    //         headers: {
    //             "api-key": "hola",
    //             'content-type': 'multipart/form-data' // do not forget this 
    //         }
    //     })
    //     return r;
    // }

    // const handleBanner = (e: any) => {
    //     console.log('banner')
    //     const file = e.target.files[0]
    //     const reader = new FileReader()
    //     reader.onloadend = () => {
    //         setBanner(reader.result)
    //     }
    //     reader.readAsDataURL(file)
    // }

    // const handleUpdate = useCallback(async () => {
    //     setUpdating(true);
    //     try {
    //         if (!isConnected) {
    //             toast.error("Please connect wallet");
    //             return;
    //         }
    //         const ethersProvider = new BrowserProvider(walletProvider as Eip1193Provider)
    //         const signer = await ethersProvider.getSigner()
    //         const msg = Buffer.from(ethers.randomBytes(24)).toString('hex')
    //         const signature = await signer.signMessage(msg)
    //         let bannerLink;
    //         if (fileBannerRef.current && fileBannerRef.current.files && fileBannerRef.current.files.length > 0) {
    //             const bannerLogoResult = await uploadLogo(fileBannerRef.current.files[0])
    //             bannerLink = bannerLogoResult.data.file.filename
    //         }
    //         const metadata = {
    //             msg,
    //             signature,
    //             tokenAddress: modal,
    //             tokenBanner: bannerLink,
    //             telegramLink: telegramLink,
    //             twitterLink: twitterLink,
    //             webLink: webLink
    //         }

    //         const { data: { success } } = await axios.post(`${SERVER_URL}/tokens`, metadata)
    //         if (success) {
    //             toast.success("Token deployed successfully")
    //         }
    //         setUpdating(false)
    //         setModal(undefined)
    //     } catch (ex) {
    //         setUpdating(false)
    //     }
    // }, [isConnected, modal, telegramLink, twitterLink, webLink, banner, walletProvider])

    // React.useEffect(() => {
    //     if (modal) {
    //         const token: any = tokens.find((t: any) => t.tokenAddress === modal)
    //         if (token) {
    //             setTelegramLink(token.telegramLink)
    //             setTwitterLink(token.twitterLink)
    //             setWebLink(token.webLink)
    //         }
    //     }
    // }, [modal])

    return (
        <PageBox mt={ isMobile ? 0 : "-92px" }>
            <ToolBox
                position="sticky"
                top={isMobile ? '80px' : 14}
                pl={ isMobile ? 0 : '430px' }
                display="flex"
                gap={{ xs: "8px", sm: "8px", md: "16px"}}
                alignItems="stretch"
                mb={1}
                zIndex={2}
            >
                {
                    !inSearch &&
                    <CreateButton to="/create" className="effect-button" style={ isMobile ? { flex: 1 } : {}}>
                        Create a token!
                        {/* <svg width="12" height="32" viewBox="3 0 32 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="animation-g1">
                            <path d="M3.87203 5.6582L1.49707 12.9758L20.675 31.999L1.49717 51.0228L3.87213 58.3426L30.4291 31.999L3.87203 5.6582Z" fill="#FFF"></path>
                        </svg>
                        <svg width="12" height="32" viewBox="3 0 32 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="animation-g2">
                            <path d="M3.87203 5.6582L1.49707 12.9758L20.675 31.999L1.49717 51.0228L3.87213 58.3426L30.4291 31.999L3.87203 5.6582Z" fill="#FFF"></path>
                        </svg>
                        <svg width="12" height="32" viewBox="3 0 32 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="animation-g3">
                            <path d="M3.87203 5.6582L1.49707 12.9758L20.675 31.999L1.49717 51.0228L3.87213 58.3426L30.4291 31.999L3.87203 5.6582Z" fill="#FFF"></path>
                        </svg> */}
                        {/* <span>C</span>
                        <span>r</span>
                        <span>e</span>
                        <span>a</span>
                        <span>t</span>
                        <span>e</span>
                        <span style={{ marginLeft: '0.2em' }}>a</span>
                        <span style={{ marginLeft: '0.2em' }}>t</span>
                        <span>o</span>
                        <span>k</span>
                        <span>e</span>
                        <span>n</span>
                        <span style={{ marginLeft: '0.2em' }}>!</span> */}
                    </CreateButton>
                }
                {
                    (!isMobile || inSearch) &&
                    <SearchToken
                        placeholder="Search for token"
                        value={searchWord}
                        fullWidth={inSearch}
                        onChange={(e) => setSearchWord(e.target.value)}
                        InputProps={searchTokenInputProps}
                    />
                }
                {
                    isMobile && !inSearch &&
                    <SearchButton onClick={() => setInSearch(true)}>
                        <SearchIcon />
                    </SearchButton>
                }
            </ToolBox>

            <Box display="flex" gap="8px" p="4px 16px" mx={{ xs: 0, sm: "-8px", md: "-15px"}} my={2} alignItems="center" bgcolor="black">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.375 15L1.5 6.375L5.25 8.25L9 3L12.75 8.25L16.5 6.375L14.625 15H3.375Z" fill="#D6DEC7" stroke="#D6DEC7" strokeWidth="1.66667" strokeLinejoin="round" />
                    <path d="M8.99902 8.25C10.4073 8.25 11.5487 9.39159 11.5488 10.7998C11.5488 12.2081 10.4073 13.3496 8.99902 13.3496C7.5908 13.3495 6.44922 12.208 6.44922 10.7998C6.44932 9.39165 7.59087 8.25011 8.99902 8.25Z" fill="#6CFF32" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
                </svg>
                <Typography fontSize={12} fontWeight="bold" color="#D6DEC7">New trending tokens</Typography>
                <IconButton sx={{ ml: "auto" }} onClick={() => pageTrendsNumber > 1 && setPageTrendsNumber(pageTrendsNumber - 1)}>
                    <ArrowBackIcon sx={{ width: 12, height: 12 }} />
                </IconButton>
                <IconButton onClick={() => pageTrendsNumber < 5 && setPageTrendsNumber(pageTrendsNumber + 1)}>
                    <ArrowForwardIcon sx={{ width: 12, height: 12 }} />
                </IconButton>
            </Box>
            <CardGrid min={180} fill space={12} ref={elementRef}>
                {
                    trends.slice(0, pageTrendSize).map((item: any) => (
                        <TokenCard key={`trend-token-${item.tokenAddress}`} token={item} mode="trends" />
                    ))
                }
            </CardGrid>
            <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap="8px" my={2} alignItems="center">
                <ComboBox label="Sort" values={{
                    bump: 'Trending',
                    marketcap: 'Market cap',
                    creationTime: 'Creation time',
                    volume: 'Trading volume',
                    // progress: 'Progress' 
                }} value={orderType} onChange={setOrderType} />
                <ComboBox label="Network" values={{
                    all: 'All',
                    ...(
                        chains?.reduce((networks, c) => ({
                            ...networks, [c.network]: c.name
                        }), {})
                    )
                }} value={network} onChange={setNetwork} />
            </Box>
            {
                tokens.length > 0 ?
                    <CardGrid min={350} space={32} mb={4}>
                        {
                            tokens.map((item: any) => (
                                <TokenCard key={item.tokenAddress} token={item} mode="list" />
                            ))
                        }
                    </CardGrid> :
                    <Typography textAlign='center' color="#aaa" my={4}>No token found</Typography>
            }
            {
                totalPage > 1 &&
                <Grid2 sx={{ display: 'flex' }} mb={5}>
                    <Stack spacing={2} mx='auto'>
                        <Pagination
                            variant="text"
                            shape="circular"
                            count={totalPage}
                            page={pageNumber}  // current page
                            onChange={handleChange}  // handle page change
                            renderItem={(data) => (
                                <PaginationItem
                                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                                    {...data}
                                />
                            )}
                        />
                    </Stack>
                </Grid2>
            }
            {/* <Dialog
                open={!!modal}
                fullWidth
                onClose={() => setModal(undefined)}
            >
                <DialogTitle>
                    Update token information
                    <IconButton onClick={() => setModal(undefined)}>
                        <CloseIcon sx={{ color: "#9E9E9E" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl variant="standard">
                        <InputLabel shrink>
                            Telegram Link
                        </InputLabel>
                        <BootstrapInput fullWidth placeholder="Telegram Link" value={telegramLink} onChange={(e) => setTelegramLink(e.target.value)} />
                    </FormControl>
                    <FormControl variant="standard">
                        <InputLabel shrink>
                            Twitter Link
                        </InputLabel>
                        <BootstrapInput fullWidth placeholder="Twitter Link" value={twitterLink} onChange={(e) => setTwitterLink(e.target.value)} />
                    </FormControl>
                    <FormControl variant="standard">
                        <InputLabel shrink>
                            Website Link
                        </InputLabel>
                        <BootstrapInput fullWidth placeholder="Website Link" value={webLink} onChange={(e) => setWebLink(e.target.value)} />
                    </FormControl>
                    <IconButton sx={{ borderRadius: '16px', textTransform: 'none', background: '#FFFFFF0F', p: '12px 20px', fontSize: 16 }} component="label">
                        Select banner image
                        <HiddenInput ref={fileBannerRef} type="file" onChange={handleBanner} />
                    </IconButton>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setModal(undefined)} color="secondary" fullWidth disabled={updating}>Close</Button>
                    <Button onClick={handleUpdate} fullWidth disabled={updating} endIcon={updating ? <CircularProgress color="inherit" size={14} /> : undefined}>
                        {updating ? "Updating" : "Update"}
                    </Button>
                </DialogActions>
            </Dialog> */}
        </PageBox>
    );
}

export default DashboardPage;
